<template>
  <div class="select-place-template"
       ref="selectgoods" :style="{ paddingTop: page === 'home' ? '15px' : '0', width: '100%'}">
    <!-- <el-input class="search-text is-input"
              :class="{'is-clear':clearable}"
              ref="selectStartInput"
              :placeholder="isHasSelectValue || value?'':placeholder"
              v-popover:startPopover
              v-model="searchText"
              :disabled="disabled"
              @input="searchChange"
              @click.stop="noEvent"
              @blur="handlerBlur"
              @focus="handlerFocus"
    ></el-input> -->
    <el-input class="search-text is-input"
              :class="{'is-clear':clearable}"
              ref="selectStartInput"
              :placeholder="isHasSelectValue || value?'':placeholder"
              v-popover:startPopover
              v-model="searchText"
              :disabled="disabled"
              @input="(val) => {
                showPopover('2'), searchChange(val)
              }"
              @click.stop="noEvent"
              @blur="handlerBlur"
              @focus="showPopover('1')"
    ></el-input>
    <div class="value-text" :style="{left: page === 'home' ? '10px' : '20px', paddingTop: page === 'home' ? '36px' : '4px'}"
         :class="[showTextStatus,clearable?'is-clear':'']"
    >
      <slot name="valueText">
        <div class="text-row" v-if="selectedValue && selectedValue.goodsName">
          {{ selectedValue ? `${selectedValue.goodsName}${selectedValue.secondName ? `/${selectedValue.secondName}` : ''}${selectedValue.firstName ? `/${selectedValue.firstName}` : ''}` : '' }}
        </div>
        <div class="text-row" v-else>
          {{ value }}
        </div>
      </slot>
    </div>
    <i v-if="selectedValue || value" class="el-icon-circle-close" style="position: absolute; font-size: 14px; color: #c0c4cc;" :style="page === 'home' ? null :{ top: '50%', marginTop: '-7px'}" @click="selectItem(null, '3')"></i>
    <!-- <span v-if="!disabled" tabindex="0" class="right-btn" @focus="showPopover('1')" @blur="handlerBlur">点我选择</span> -->

    <el-popover
      :popper-class="`input-popover-template-popper ${popperClass}`"
      :visible-arrow="false"
      ref="startPopover"
      trigger="manual"
      placement="bottom-start"
      title=""
      :offset="offset"
      v-model="visiblePopover"
      @show="handlerShow"
      @after-leave="handlerAfterLeave"
    >
      <div v-if="showType === '1'" class="goods-list-box">
        <div v-if="levelLoading">
          <i class="el-icon-loading"></i> 正在加载中...
        </div>
        <template v-else>
          <div class="goods-type-level1" v-if="firstList.length">
            <ul>
              <li v-for="(item, i) in firstList" :key="i" :class="{isActive: firstActive && firstActive.id === item.id}" @click="selectFirst(item)">
                {{ item.productTypeFirstName }}
                <i class="el-icon-arrow-right"></i>
              </li>
            </ul>
          </div>
          <div class="goods-type-level1" v-else>
            <p>抱歉，暂无数据</p>
          </div>
          <div class="goods-type-level2" v-if="firstActive">
            <ul v-if="secondList.length">
              <li v-for="(item, i) in secondList" :key="i" :class="{isActive: secondActive && secondActive.id === item.id}" @click="selectSecond(item)">
                <div>
                  {{ item.productTpeSecondaryName }}
                  <p class="price-info">加收 {{ item.price || 0 }} {{ item.currency || 'CNY' }}/{{item.billingUnit || 'KG'}}</p>
                </div>
                <i class="el-icon-arrow-right"></i>
              </li>
            </ul>
            <p v-else>抱歉，暂无数据</p>
          </div>
          <div class="goods-type-level3" v-if="firstActive && secondActive">
            <el-input v-model="searchInfo" placeholder="请输入商品名称搜索" @input="searchInfoChange"></el-input>
            <div class="product-wrap">
              <ul v-if="productItems.length && !searchInfo">
                <li :title="item.productName" v-for="item in productItems" :key="item.id" :class="{isActive: productActive && item.id === productActive.id}" @click="selectProductItem(item, '1')">{{ item.productName }}</li>
              </ul>
              <ul v-else-if="searchInfoFilerList.length && searchInfo">
                <li :title="item.productName" v-for="item in searchInfoFilerList" :key="item.id" :class="{isActive: productActive && item.id === productActive.id}" @click="selectProductItem(item, '1')">{{ item.productName }}</li>
              </ul>
              <div v-else style="min-width: 224px; padding: 32px 0 54px 0;text-align: center;">
                <img :src="ossPath + '/pages/home/no-data.png'" alt="">
                <p style="margin-top: 33px">抱歉，暂未找到相关产品品名</p>
              </div>
            </div>
          </div>
        </template>
      </div>
      <div v-else class="goods-options">
        <div v-if="isLoading">
          <i class="el-icon-loading"></i> 正在搜索中...
        </div>
        <template v-else>
          <ul v-if="productList.length">
            <li class="goods-option" :class="{isActive: selectedValue && item.id === selectedValue.id}" v-for="item in productList" :key="item.id" @click="selectItem(item, '2')">
              <span  style="display:inline-block; width: 200px; margin-right: 10px;">
                {{item ? `${item.goodsName || item.namec}${item.secondName || item.productTypeName ? `/${item.secondName || item.productTypeName}` : ''}${item.firstName || item.productName ? `/${item.firstName || item.productName}` : ''}` : '' }}
              </span>
              <span style="float: right; color: #FF4D01; font-size: 13px"><span style="color: #444">加收 </span>{{ item.surcharge || item.price || 0 }} {{ item.currency || 'CNY' }}/{{item.billingUnit || 'KG'}}</span>
            </li>
          </ul>
          <div v-else align="center" style="min-width: 330px; padding: 32px 0 54px 0">
            <img :src="ossPath + '/pages/home/no-data.png'" alt="">
            <p style="margin-top: 33px">{{searchText ? '抱歉，暂未找到相关产品品名' : '请输入商品名称搜索'}}</p>
          </div>
        </template>
      </div>
    </el-popover>

  </div>
</template>

<script>
import {isArray, isObject,debounce} from "my-tools-kit";
export default {
  props: {
    page: {
      type: String,
      default: 'home'
    },
    countryId: {
      type: [String, Number],
      default: ''
    },
    value:{ // 选中值,单选Object/Array[{}],多选必须Array
      type:[Object,Array,String],
      default:()=>({}),
    },
    disabled:{ // 输入框是否禁用，禁用情况下点击输入框页无法弹出列表
      type:Boolean,
      default:false,
    },
    clearable:{ // 是否可清空
      type:Boolean,
      default:true,
    },
    selectItemCallback:{// 选中某项item时（或全选时），会调用该callback,返回true/false
      type:Function
    },
    isLoading:{ // 显示 正在请求数据中...
      type:Boolean,
      default:false,
    },
    loadingText:{ // 加载时显示的文本
      type:String,
      default:"正在请求数据中...",
    },
    placeholder:{ //输入框提示信息
      type:String,
      default:"请输入起运地",
    },
    noDataMessage:{ //列表为空时的提示信息
      type:String,
      default:"暂未找到您要的信息",
    },
    popoverWidth:{ //弹出层宽度
      type:String,
      default:"400",
    },
    offset:{ //出现位置的偏移量
      type:Number,
      default:0,
    },
    popperClass:{ // 弹窗class
      type:String,
      default:"",
    },
    productList: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      /* 筛选 */
      searchText:"",//输入框搜索文本
      searchLoading:false,//筛选状态
      searchFilerList:[],//筛选出的列表
      /* */
      isFocus:false,//当前输入框是否获得焦点
      visiblePopover:false,// 显示弹出层
      showType: null,
      selectedValue: null,
      // filterTimer: null
      levelData: [],
      firstList: [],
      // secondList: [],
      secondList: [],
      firstActive: null,
      secondActive: null,
      productItems: [],
      productActive: null,
      searchInfo: '',
      searchInfoFilerList: [],
      searchInfoLoading: false,
      levelLoading: false
    }
  },
  methods: {

    /**
     * 触发搜索
     */
     changeSearch:debounce(function(text = this.searchInfo){
      text = text.replace(/(^\s+)|(\s+$)/g,"");
      console.log(text);
      // text = text.toUpperCase();
      let baseList = this.productItems
      let filterList = [];
      filterList = this.searchList(text,baseList);
      this.searchInfoFilerList = filterList;
      this.searchInfoLoading = false;

    },200,false),
    /**
     * 搜索函数
     * @param text  {string}  搜索文本
     * @param baseList  {array} tabItem对应的list数据
     * @param tabItem {object}  tabHeadList列表的某项item
     * @returns {*[]}
     */
    searchList(text="",baseList=[]){
      let filterList = [];
      let hasCallback = typeof this.searchCallback === "function";
      let filterFunction = (text="",item)=>{
        // console.log("============",item[this.itemLabelKey])
        let itemLabel = String(item.productName||"");
        let itemLabelE = String(item.productNameE||"");
        let reg = RegExp(text,"ig");
        return reg.test(itemLabel) || reg.test(itemLabelE);
      };
      filterList = baseList.filter(item=>{
        return hasCallback ? this.searchCallback(text,item) : filterFunction(text,item);
      });
      return filterList;
    },
    noEvent(){},
    showPopover(type) {
      this.showType = type
      this.showListPopover()
      if (type == 1) this.searchText = "";
      this.getLevelList()
    },
    handlerBlur() {
      this.isFocus = false;
      this.$emit('blur');
      // this.hideListPopover();
    },
    // closeOtherDownMask(){
    //   const _event = document.createEvent("MouseEvents");
    //   _event.initEvent("click",true,true);
    //   document.body.dispatchEvent(_event);
    // }
    /**
     * 获得焦点时触发
     */
    handlerFocus(){
      this.showType = '2'
      this.isFocus = true;
      this.$emit('focus');
      this.showListPopover();
    },
    /**
     * 显示、隐藏列表
     */
    showListPopover() {
      if (this.showType === '2' && !this.searchText) return
      this.visiblePopover = true;
    },
    hideListPopover(e){
      this.visiblePopover = false;
      this.searchText = "";
    },
    handlerShow() {},
    handlerAfterLeave() {},
    /**
     * 全局关闭
     */
    globalClosePopover(e){
      let screenDoc = this.$refs.selectgoods;
      if (screenDoc && !screenDoc.contains(e.target)) this.hideListPopover();
    },
    async getLevelList() {
      const data = {
        countryId: this.countryId
      }
      this.levelLoading = true
      this.axios.post('/api/product/selectHomePageAllProductFeeByCountryAndType', data)
        .then(res => {
          this.levelLoading = false
          this.levelData = res.data.datas || []
          this.firstList = res.data.datas || []
        }).catch(() => {
          this.levelLoading = false
        })
    },
    searchChange:debounce(function(val) {
      // if (val) this.showListPopover()
      if (!val) return this.showPopover('1')
      this.$emit('remoteMethod', val)
    },500,false),
    selectItem(item, type) {
      // type：1:精确2:检索3:清空
      if (item) {
        item.goodsName = item.goodsName || item.namec
        item.secondName = item.secondName || item.productTypeName
        item.firstName = item.firstName || item.productName
      } else {
        this.selectedValue = null
        this.levelData = []
        this.firstList = []
        this.firstActive = null
        this.secondList = []
        this.secondActive = null
        this.productItems = []
        this.searchInfo = ''
        this.searchInfoFilerList = []
        this.productActive = null
      }
      if (type === '3' || !type) {
        this.selectedValue = null
        this.levelData = []
        this.firstList = []
        this.firstActive = null
        this.secondList = []
        this.secondActive = null
        this.productItems = []
        this.searchInfo = ''
        this.searchInfoFilerList = []
        this.productActive = null
      } else if (type === '2') {
        this.firstActive = null
        this.secondActive = null
        this.searchInfo = ''
        this.productActive = null
      }
      this.selectedValue = item
      this.$emit('change', this.selectedValue ? `${this.selectedValue.goodsName}${this.selectedValue.secondName ? `/${this.selectedValue.secondName}` : ''}${this.selectedValue.firstName ? `/${this.selectedValue.firstName}` : ''}` : '')
      this.hideListPopover()
    },
    selectProductItem(item) {
      item.goodsName = item.productName
      item.firstName = this.firstActive.productTypeFirstName
      item.secondName = this.secondActive.productTpeSecondaryName
      this.selectedValue = item
      this.productActive = item
      this.$emit('change', this.selectedValue ? `${this.selectedValue.goodsName}${this.selectedValue.secondName ? `/${this.selectedValue.secondName}` : ''}${this.selectedValue.firstName ? `/${this.selectedValue.firstName}` : ''}` : '')
      this.hideListPopover()
    },
    selectFirst(val) {
      this.firstActive = val
      this.secondList = val.productTpeSecondaryNameList
      this.secondActive = null
    },
    selectSecond(val) {
      this.secondActive = val
      this.productItems = val.productList
      this.searchInfo = ''
      this.searchInfoFilerList = []
    },
    searchInfoChange(val) {
      this.changeSearch(val)
      // const data = {
      //   countryId: this.countryId,
      //   productName: val,
      //   productTypeFirstName: this.firstActive.productTypeFirstName,
      //   productTypeSecondaryName: this.secondActive.productTypeSecondaryName
      // }
      // this.productLoading = true
      // this.axios.post('/api/product/selectHomePageAllProductFeeByCountryAndType', data)
      //   .then(res => {
      //     this.productItems = res.data.datas && res.data.datas.length ? res.data.datas[0].productTpeSecondaryNameList.productList : []
      //   })
    }
  },
  watch: {
    countryId() {
      this.selectedValue = null
      this.levelData = []
      this.firstList = []
      this.firstActive = null
      this.secondList = []
      this.secondActive = null
      this.productItems = []
      this.searchInfo = ''
      this.searchInfoFilerList = []
    }
  },
  computed:{
    /**
     * 回显文本状态 class
     * @returns {string}
     */
    showTextStatus(){
      // 搜索框有输入值
      if(this.searchText.length) return "opacity-0"
      // 搜索框没有输入值，但是聚焦状态
      if(this.isFocus) return "opacity-04"
      return "";
    },
    /**
     * 是否有选中值
     * @returns {*}
     */
    isHasSelectValue(){
      // 有选中值时 输入框不显示placeholder
      let value = this.selectedValue;
      return isObject(value)
    },
  },
  created() {
    // this.countDefaultSelect();
    document.addEventListener("click",this.globalClosePopover,false);
  },
  destroy() {
    document.removeEventListener("click",this.globalClosePopover);
  },
}
</script>

<style lang="scss" scoped>
/* 搜索框 */
.search-text{
  position: relative;
  z-index: 1;
  // width: 114px;
  width: calc(100% - 20px);
  height: 100%;
  font-size: 16px;
  &,
  /deep/ input{
    background-color: transparent !important;
  }
  /deep/ input{
    min-width: auto;
    width: 100%;
    height: 100%;
    border: none;
  }
  &:not([class~="is-input"]){
    display: flex;
    align-items: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding: 0 15px;
    cursor: pointer;
    color: #999;
  }
  &.is-clear{
    /deep/ input{
      padding-right: 0;
    }
    &:not([class~="is-input"]){
      padding-right: 0;
    }
  }
}

/* 选中值回显文本 */
.value-text{
  // width: 116px;
  width: calc(100% - 30px);
  position: absolute;
  z-index: 0;
  top: 0;
  bottom: 0;
  // left: 0;
  // right: 0;
  display: flex;
  align-items: center;
  align-content: center;
  flex-wrap: wrap;
  transition: opacity 0.4s ease;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  &.is-clear{
    // right: 30px;
  }
}
.opacity-0{
  opacity: 0;
}
.opacity-04{
  opacity: 0.4;
}
.text-row{
  padding-left: 12px;
  font-size: 16px;
  color: #333333;
  line-height: 30px;
  width: calc(100% - 16px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.right-btn {
  float: right;
  margin-right: 4px;
  color: #FF4D01;
  font-size: 14px;
  cursor: pointer;
}
.goods-list-box {
  display: flex;
  .goods-type-level1, .goods-type-level2, .goods-type-level3 {
    max-height: 300px;
    overflow-y: auto;
    /deep/ .el-input__inner {
      background: #F7F7F7;
      border: none
    }
    .product-wrap {
      max-width: 224px;
      padding: 10px 0;
      ul {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        li {
          padding: 3px 4px;
          width: calc(33% - 8px);
          line-height: 20px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          cursor: pointer;
          &.isActive {
            background-color: #FFF1F2;
          }
        }
      }
    }
  }
  .goods-type-level1, .goods-type-level2 {
    padding: 0 4px;
    // margin-right: 10px;
    width: 160px;
    line-height: 30px;
    li {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 4px 10px;
      font-size: 16px;
      cursor: pointer;
      &:hover {
        background: #F5F7FA;
      }
      &.isActive {
        background: #FFF1F2;
      }
      .price-info{
        color: #FF4D01;
        font-size: 12px;
      }
    }
  }
  .goods-type-level2, .goods-type-level3 {
    // margin-left: 10px;
    padding-left: 10px;
    border-left: 1px solid #efefef;
  }
}
.goods-options {
  max-height: 300px;
  overflow-y: auto;
  .goods-option {
    line-height: 30px;
    cursor: pointer;
    &:hover {
      background: #F5F7FA;
    }
  }
  .isActive {
    background: #FFF1F2;
  }
}
</style>



// WEBPACK FOOTER //
// common/goods-select/index.vue